import React from "react";
import Header from "../Pages/Home/Header";
import Services from "../Pages/Home/Services";
import Treatments from "../Pages/Home/Treatments";
import Doctors from "../Pages/Home/Doctors";
import Accesories from "../Pages/Home/Accesories";
import News from "../Pages/Home/News";
import Reviews from "../Pages/Home/Reviews";
import Seminars from "./Seminars";
import HowWorks from "../Pages/Home/HowWorks";
import { easeIn, motion } from "framer-motion";
import { logo } from "../assets";

const Homepage = ({
  setSingleDoc,
  setSingleSeminar,
  setSingleBlog
}) => {
  return (
    <div id="homepage">
      <motion.div
        className="slide-in"
        whileInView={{ scaleY: [1, 0] }}
        transition={{ duration: 1, ease: easeIn, delay: 1.3 }}
      >
        <motion.img
          src={logo}
          alt=""
          whileInView={{ opacity: [1, 0] }}
          transition={{ duration: 1, delay: 0.5 }}
        />
      </motion.div>
      <Header />
      <Services />
      <Doctors setSingleDoc={setSingleDoc} />
      <Seminars setSingleSeminar={setSingleSeminar} />
      <Accesories />
      <Treatments />
      <Reviews />
      <News setSingleBlog={setSingleBlog} />
      <HowWorks />
    </div>
  );
};

export default Homepage;
